export default Object.freeze({
  AUTH: 'auth',
  APPLICATION_HUB: 'application-hub',
  HOME: 'home',
  START: 'start',

  // DIRECTORY
  LICENSE: 'license',
  USERS: 'users',
  DEVICES: 'devices',

  // ROUTING
  FLOW: 'flow',
  DIALPLAN: 'dialplan',
  GATEWAYS: 'gateways',
  CHATPLAN: 'chatplan',
  CHAT_GATEWAYS: 'chat-gateways',

  // LOOKUPS
  SKILLS: 'skills',
  BUCKETS: 'buckets',
  BLACKLIST: 'blacklists',
  REGIONS: 'regions',
  CALENDARS: 'calendars',
  COMMUNICATIONS: 'communications',
  PAUSE_CAUSE: 'agent-pause-cause',
  MEDIA: 'media',

  // CONTACT-CENTER
  AGENTS: 'agents',
  TEAMS: 'teams',
  RESOURCES: 'resources',
  RESOURCE_GROUPS: 'resource-groups',
  QUEUES: 'queues',
  MEMBERS: 'queues-members',

  // INTEGRATIONS
  STORAGE: 'storage',
  COGNITIVE_PROFILES: 'cognitive-profiles',
  EMAIL_PROFILES: 'email-profiles',
  IMPORT_CSV: 'import-csv',
  TRIGGERS: 'triggers',

  // PERMISSIONS
  OBJECTS: 'objects',
  ROLES: 'roles',

  SETTINGS_PAGE: 'settings',
  PAGE_403: 'access-denied',
  PAGE_404: '',
});
